import { ESIInclude } from "@packages/esi-include/SimpleESIInclude";

export function Footer() {
  const srcUrl = "/esi/footer";

  return (
    <div data-testid="footer" data-component="Footer">
      <ESIInclude src={srcUrl} id="web-plp-scaffold-ui-footer" />
    </div>
  );
}
